import { PrechatFieldType } from "../../store/definitions";
import { isValidCpf, maskCpf } from "../../utils/validateCpf";

/*
 * Comportamento de um campo do form pré-chat, isolado por tipo. Centraliza máscara, validação,
 * erro inline e atributos de input num único lugar (strategy map) — o ponto de extensão pra
 * implementar `email`/`phone` de verdade é SÓ este arquivo (Open/Closed).
 */
type FieldBehavior = {
    mask: (raw: string) => string;
    isValid: (value: string, required: boolean) => boolean;
    /* Erro inline (ex.: "CPF inválido") — só faz sentido em tipos com formato. */
    showError: (value: string) => boolean;
    errorText?: string;
    inputMode?: "numeric";
    maxLength: number;
};

const identity = (value: string) => value;
const requiredNonEmpty = (value: string, required: boolean) => (required ? Boolean(value.trim()) : true);

/*
 * Base "text": coleta + valida obrigatório, sem máscara/formato. `email` e `phone` DEGRADAM pra
 * text hoje (decisão: nada de validador não-exercitado em prod) — quando uma marca precisar de
 * verdade, criar o behavior próprio aqui com TDD.
 */
const TEXT_BEHAVIOR: FieldBehavior = {
    mask: identity,
    isValid: requiredNonEmpty,
    showError: () => false,
    maxLength: 50
};

const FIELD_BEHAVIORS: Record<PrechatFieldType, FieldBehavior> = {
    cpf: {
        mask: maskCpf,
        isValid: (value) => isValidCpf(value),
        // Erro só "pipoca" quando os 11 dígitos foram digitados e o número é inválido.
        showError: (value) => value.replace(/\D/g, "").length === 11 && !isValidCpf(value),
        errorText: "CPF inválido",
        inputMode: "numeric",
        maxLength: 14
    },
    text: TEXT_BEHAVIOR,
    email: TEXT_BEHAVIOR,
    phone: TEXT_BEHAVIOR
};

/* Fallback pra text em tipo desconhecido (config externa pode driftar) — defensivo, nunca quebra. */
export const getFieldBehavior = (type: PrechatFieldType): FieldBehavior => FIELD_BEHAVIORS[type] ?? TEXT_BEHAVIOR;
